import { createLucideIcon, type IconNode } from "lucide-react";

/**
 * Glyphen, die lucide nicht hat — im selben 24er-Raster und mit derselben
 * Strichfuehrung gezeichnet, damit sie neben den lucide-Glyphen als eine
 * Familie lesen. `scripts/gen-app-icons.mjs` importiert diese Datei, damit die
 * PNG-Saetze aus derselben Form entstehen wie das Glyph im Kopf.
 */

// Janimo, der Begleiter: Kuppel mit zwei grossen Augen und Haartolle. Bewusst
// NICHT das Vollbild-Gesicht der PWA — das faellt aus der Icon-Familie (Betreiber 2026-10-19).
export const JANIMO_NODE: IconNode = [
  ["path", { d: "M4 14a8 8 0 0 1 16 0v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z", key: "kuppel" }],
  ["circle", { cx: "8.5", cy: "14.5", r: "2.25", key: "auge-l" }],
  ["circle", { cx: "15.5", cy: "14.5", r: "2.25", key: "auge-r" }],
  ["path", { d: "M12 6c0-2 1.2-3 3-3", key: "tolle" }],
];

export const Janimo = createLucideIcon("Janimo", JANIMO_NODE);

// DevOps: Team-Baum — oben die Projektleitung, darunter drei Zweige zu den Rollen. Die Lemniskate
// (lucide Infinity) las sich als „Unendlich“ und sagte nichts ueber das Team.
export const DEVOPS_NODE: IconNode = [
  ["circle", { cx: "12", cy: "5", r: "2", key: "wurzel" }],
  ["path", { d: "M12 7v10", key: "stamm" }],
  ["path", { d: "M5 17v-2a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v2", key: "ast" }],
  ["circle", { cx: "5", cy: "19", r: "2", key: "blatt-l" }],
  ["circle", { cx: "12", cy: "19", r: "2", key: "blatt-m" }],
  ["circle", { cx: "19", cy: "19", r: "2", key: "blatt-r" }],
];

export const Devops = createLucideIcon("Devops", DEVOPS_NODE);

/** Name → Glyph, fuer Werkzeuge, die Glyphen per Name aufloesen. */
export const EIGENE_GLYPHEN = { Janimo, Devops } as const;
